import { faTimes, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useEffect, useMemo } from "react";
import { Toolbox } from "../components";
import { GrigoraEditorContext } from "../context";
import { AnimatePresence, motion } from "framer-motion";
import { Rnd } from "react-rnd";
const Elements = ({ leftWidget }) => {
  const { isAddingBlocks, setIsAddingBlocks } =
    useContext(GrigoraEditorContext);

  const [size, setSize] = React.useState({
    width: 400,
    height: 600,
    x: 50,
    y: 50,
  });

  const dragHandlers = useMemo(() => {
    return {
      onDragStart: (e) => {
        // Set pointer events to auto
        document
          .querySelector(".helper-container")
          ?.style?.setProperty("pointer-events", "auto");
      },
      onDragStop: (e, d) => {
        // Set pointer events to none
        setSize({ ...size, x: d.x, y: d.y });
        document
          .querySelector(".helper-container")
          ?.style?.setProperty("pointer-events", "none");
      },
      size: { width: size.width, height: size.height },
      position: { x: size.x, y: size.y },
      onResizeStart: () => {
        document
          .querySelector(".helper-container")
          ?.style?.setProperty("pointer-events", "auto");
      },
      onResizeStop: (e, direction, ref, delta, position) => {
        document
          .querySelector(".helper-container")
          ?.style?.setProperty("pointer-events", "none");

        setSize({
          width: ref.style.width,
          height: ref.style.height,
          ...position,
        });
      },
      style: {
        display: "flex",
        zIndex: 1000,
        // flex: 1,
      },
      minWidth: 220,
      minHeight: 300,
      bounds: ".page-container",
      className: "elements-widget",
    };
  }, [size]);

  useEffect(() => {
    if (isAddingBlocks) {
      // Set self display to flex
      document
        .querySelector(".elements-widget")
        ?.style?.setProperty("display", "flex");
    }
  }, [isAddingBlocks]);

  return (
    <>
      <AnimatePresence>
        {isAddingBlocks && (
          <Rnd dragHandleClassName="block-elements__header" {...dragHandlers}>
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.1 }}
              style={{ originX: 0, originY: 0 }}
              className="elements box no-cursor w-full bg-white border border-gray-200 rounded-[10px] overflow-hidden z-[1001] flex flex-col shadow-editor-floating-elements"
            >
              <div className="block-elements__header cursor-grab px-3 py-3 flex items-center">
                <h4 className="flex items-center w-full ml-3 text-[16px] font-medium">
                  Add Elements
                  <div
                    onClick={() => {
                      setIsAddingBlocks(false);
                    }}
                    className="float-right flex items-center justify-center ml-auto p-1 mr-3 w-[23px] h-[23px] duration-300 rounded-full hover:bg-gray-100 cursor-pointer"
                  >
                    <FontAwesomeIcon icon={faXmark} />
                  </div>
                </h4>
              </div>
              <div className="toolbox-container grigora-hidden-scrollbar">
                <Toolbox />
              </div>
            </motion.div>
          </Rnd>
        )}
      </AnimatePresence>
    </>
  );
};

export default Elements;
